import { useLocalObservable } from 'mobx-react-lite';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps } from '@gem/popups';

import Tasks from 'APP/Tasks';

interface ISecretChatRequestPopupPresenter {
  onClose(): void;
  onBack(): void;
  onRequest(): Promise<void>;
  isLoading: boolean;
}

interface ISecretChatRequestPopupPresenterProps {
  groupId: string;
}

export function useSecretChatRequestPopupPresenter({
  popupInstance,
  onClose,
  onBack,
  params,
}: ICommonPopupsProps<ISecretChatRequestPopupPresenterProps>): ISecretChatRequestPopupPresenter {
  const { t } = useTranslation();
  const presenter = useLocalObservable<ISecretChatRequestPopupPresenter>(() => ({
    isLoading: false,

    onClose(): void {
      popupInstance.close();
      onClose?.();
    },

    onBack(): void {
      popupInstance.close();
      onBack?.();
    },

    async onRequest(): Promise<void> {
      presenter.isLoading = true;
      const result = await Tasks.e2ee.secretChatRequestAccess(params!.groupId);

      if (result) {
        Tasks.app.showToast(t('secure_chat_request_sent'));
        presenter.onClose();
      } else {
        Tasks.app.showToast(t('something_went_wrong'));
      }
      presenter.isLoading = false;
    },
  }));

  return presenter;
}
